<template>
  <div>
    <modal
      name="assetSearch"
      :adaptive="true"
      height="auto"
      width="1200px"
      class="u-text-align-center"
      :click-to-close="false"
      @close="hide">
      <div class="asset-modal">
        <div class="page-block">
          <div class="page-block__heading page-block__heading--withbar">
            <h3 class="page-block__title">アセット検索</h3>
            <span
              style="float: right;padding: 4px;"
              class="close-button"
              @click="hide">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                x="0px"
                y="0px"
                width="20"
                height="20"
                viewBox="0,0,256,256">
                <g
                  fill="#595959"
                  fill-rule="nonzero"
                  stroke="none"
                  stroke-width="1"
                  stroke-linecap="butt"
                  stroke-linejoin="miter"
                  stroke-miterlimit="10"
                  stroke-dasharray=""
                  stroke-dashoffset="0"
                  font-family="none"
                  font-weight="none"
                  font-size="none"
                  text-anchor="none"
                  style="mix-blend-mode: normal">
                  <g transform="scale(8.53333,8.53333)">
                    <path
                      d="M7,4c-0.25587,0 -0.51203,0.09747 -0.70703,0.29297l-2,
                    2c-0.391,0.391 -0.391,1.02406 0,1.41406l7.29297,7.29297l-7.29297,
                    7.29297c-0.391,0.391 -0.391,1.02406 0,1.41406l2,2c0.391,
                    0.391 1.02406,0.391 1.41406,0l7.29297,-7.29297l7.29297,
                    7.29297c0.39,0.391 1.02406,0.391 1.41406,0l2,-2c0.391,
                    -0.391 0.391,-1.02406 0,-1.41406l-7.29297,-7.29297l7.29297,
                    -7.29297c0.391,-0.39 0.391,-1.02406 0,-1.41406l-2,-2c-0.391,
                    -0.391 -1.02406,-0.391 -1.41406,0l-7.29297,7.29297l-7.29297,
                    -7.29297c-0.1955,-0.1955 -0.45116,-0.29297 -0.70703,-0.29297z">
                    </path>
                  </g>
                </g>
              </svg>
            </span>
          </div>
          <div class="page-block__inner">
            <assets-search
              pre-search-keyword=""
              :video-id="videoId"
              @on-row-clicked="onRowClicked" />
            <a
              href="#"
              class="c-btn c-btn--back"
              @click.prevent="hide">
              閉じる
            </a>
          </div>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import YouTubeAssetsSearch from './Search'

export default {
  name: 'YouTubeAssetsDialog',
  components: {
    AssetsSearch: YouTubeAssetsSearch,
  },
  props: {
    isShown: {
      type: Boolean,
      default: false,
    },
    videoId: {
      type: String,
      default: '',
    },
  },
  watch: {
    isShown() {
      if (this.isShown) {
        this.show()
      } else {
        this.hide()
      }
    },
  },
  methods: {
    onRowClicked(id) {
      this.$emit('row-clicked', id)
    },
    show() {
      this.$modal.show('assetSearch')
    },
    hide() {
      this.$modal.hide('assetSearch')
      this.$emit('closed')
    },
  },
}
</script>

<style scoped>
.asset-modal {
  padding: 2vmin;
}
@media screen and (min-width: 896px) {
  .asset-modal {
    max-height: 80vh!important;
    overflow: scroll;
  }
}
@media screen and (max-width: 895px) {
  .asset-modal {
    height: 90vh!important;
    overflow: scroll;
  }
}
</style>
